export const RESOURCE_INVENTORY_PATHS = {
  resourceInventory: '/resource-inventory/list',
  resourceInventoryMyShelf: '/resource-inventory/my-shelf',
  resourceInventoryMyEntries: '/resource-inventory/my-entries',
  resourceInventorySubmitResource: '/resource-inventory/submit-resource'
} as const
